import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';

class Form extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    error: PropTypes.string
  };

  renderHiddenField = data => {
    return (
      <input
        {...data.input}
        type={'hidden'}
        step={data.step}
        id={`organization_${data.input.name}`}
        readOnly={data.readOnly || false}
        disabled={data.disabled || undefined}
      />
    );
  };

  renderField = data => {
    data.input.className = 'form-control';

    const isInvalid = data.meta.touched && !!data.meta.error;
    if (isInvalid) {
      data.input.className += ' is-invalid';
      data.input['aria-invalid'] = true;
    }

    if (this.props.error && data.meta.touched && !data.meta.error) {
      data.input.className += ' is-valid';
    }

    return (
      <div className={`form-group`}>
        <label
          htmlFor={`organization_${data.input.name}`}
          className="form-control-label"
        >
          {data.label || data.input.name}
        </label>
        <input
          {...data.input}
          type={data.type}
          step={data.step}
          required={data.required}
          placeholder={data.placeholder}
          id={`organization_${data.input.name}`}
        />
        {isInvalid && <div className="invalid-feedback">{data.meta.error}</div>}
      </div>
    );
  };

  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        {!!this.props.isCreate && (
          <Field
            component={this.renderHiddenField}
            name="ownerEmail"
            label="Email"
            type="text"
            placeholder=""
            readOnly={true}
            disabled={true}
          />
        )}
        <Field
          component={this.renderField}
          name="name"
          label="Name"
          type="text"
          placeholder=""
        />

        <button type="submit" className="btn btn-cta">
          Submit
        </button>
      </form>
    );
  }
}

export default reduxForm({
  form: 'organization',
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})(Form);
